module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70305/img/blog-post-zero.png"